import React from "react";
import { Route, Switch } from "react-router-dom";
import { usePrivateRoute } from "../authentication/hooks";
import {
  Contacts,
  NewCustomer,
  Users,
  UsersEdit,
  UsersNew,
  MyProfile,
  Credentials,
  General,
} from "./pages";
import "react-phone-input-2/lib/material.css";
import { Layout, Logout } from "./components";
import { MainContext } from "./contexts";
import { Rules } from "modules/distribution/pages";
import { RuleForm } from "modules/distribution/pages/RuleForm";
import { WhatsappAlert } from "./components/WhatsappAlert";
import { LoadCredentials } from "./components/LoadCredentials";
import * as storage from "./utils/storage";
import { TagsManager } from "./pages/TagsManager";
import { TagsForm } from "./pages/TagsForm";

storage.init();

export const App = function () {
  usePrivateRoute();

  return (
    <MainContext>
      <Layout>
        <Switch>
          <Route exact path="/app" component={Contacts} />
          <Route path="/app/chat/:id" component={Contacts} />
          <Route path="/app/customer/new" component={NewCustomer} />
          <Route exact path="/app/users" component={Users} />
          <Route exact path="/app/users/new" component={UsersNew} />
          <Route path="/app/users/:id" component={UsersEdit} />
          <Route exact path="/app/profile" component={MyProfile} />
          <Route exact path="/app/credentials" component={Credentials} />
          <Route path="/app/logout" component={Logout} />
          <Route exact path="/app/rules" component={Rules} />
          <Route exact path="/app/rules/new" component={RuleForm} />
          <Route path="/app/rules/:id" component={RuleForm} />
          <Route path="/app/reports/general" component={General} />
          <Route exact path="/app/tags" component={TagsManager} />
          <Route exact path="/app/tags/new" component={TagsForm} />
          <Route path="/app/tags/:id" component={TagsForm} />
        </Switch>

        <LoadCredentials />
        <WhatsappAlert />
      </Layout>
    </MainContext>
  );
};
